module.exports = __webpack_public_path__ + "static/media/pokeball.f10bf078.png";